module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-eBook-w720.4e871c53.jpg";